const themes = [
  {
    id: 'default',
    color: '#ffffff',
    source: {
      typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: { fontWeight: 700 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 700 },
        h4: { fontWeight: 600 },
        h5: { fontWeight: 600 },
        h6: { fontWeight: 600 },
        body1: { fontSize: '0.9375rem' },
        body2: { fontSize: '0.875rem' },
      },
      palette: {
        primary: {
          light: '#ff9e45',
          main: '#fe7303',
          dark: '#d45f00',
          contrastText: '#ffffff',
        },
        secondary: {
          main: '#2ecc71',
          contrastText: '#ffffff',
        },
        background: {
          default: '#f4f6f9',
          paper: '#ffffff',
        },
        text: {
          primary: '#1e2129',
          secondary: '#5e6278',
          disabled: '#a1a5b7',
        },
        divider: '#e9ecef',
      },
      shape: {
        borderRadius: 8,
      },
      shadows: [
        'none',
        '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
        '0 2px 6px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)',
        '0 4px 12px rgba(0,0,0,0.07)',
        '0 6px 16px rgba(0,0,0,0.08)',
        '0 8px 24px rgba(0,0,0,0.08)',
        '0 10px 28px rgba(0,0,0,0.09)',
        '0 12px 32px rgba(0,0,0,0.09)',
        '0 14px 36px rgba(0,0,0,0.10)',
        '0 16px 40px rgba(0,0,0,0.10)',
        '0 18px 44px rgba(0,0,0,0.10)',
        '0 20px 48px rgba(0,0,0,0.11)',
        '0 22px 52px rgba(0,0,0,0.11)',
        '0 24px 56px rgba(0,0,0,0.11)',
        '0 26px 60px rgba(0,0,0,0.12)',
        '0 28px 64px rgba(0,0,0,0.12)',
        '0 30px 68px rgba(0,0,0,0.12)',
        '0 32px 72px rgba(0,0,0,0.13)',
        '0 34px 76px rgba(0,0,0,0.13)',
        '0 36px 80px rgba(0,0,0,0.13)',
        '0 38px 84px rgba(0,0,0,0.14)',
        '0 40px 88px rgba(0,0,0,0.14)',
        '0 42px 92px rgba(0,0,0,0.14)',
        '0 44px 96px rgba(0,0,0,0.15)',
        '0 46px 100px rgba(0,0,0,0.15)',
      ],
      overrides: {
        MuiCssBaseline: {
          '@global': {
            body: {
              backgroundColor: '#f4f6f9',
            },
          },
        },
        MuiButton: {
          root: {
            borderRadius: 8,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.875rem',
            padding: '8px 20px',
          },
          contained: {
            boxShadow: 'none',
            '&:hover': {
              boxShadow: '0 6px 16px rgba(254,115,3,0.40)',
            },
          },
          containedPrimary: {
            background: 'linear-gradient(135deg, #fe7303 0%, #ff9e45 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #e66500 0%, #fe8c22 100%)',
              boxShadow: '0 6px 16px rgba(254,115,3,0.45)',
            },
          },
        },
        MuiPaper: {
          rounded: {
            borderRadius: 12,
          },
          elevation1: {
            boxShadow: '0 2px 8px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.05)',
          },
          elevation2: {
            boxShadow: '0 4px 14px rgba(0,0,0,0.09)',
          },
        },
        MuiCard: {
          root: {
            borderRadius: 12,
            boxShadow: '0 2px 8px rgba(0,0,0,0.07), 0 1px 3px rgba(0,0,0,0.04)',
            border: '1px solid #eaecf0',
            transition: 'box-shadow 0.2s ease, transform 0.2s ease',
            '&:hover': {
              boxShadow: '0 8px 24px rgba(0,0,0,0.11)',
              transform: 'translateY(-1px)',
            },
          },
        },
        MuiOutlinedInput: {
          root: {
            borderRadius: 8,
            '&:hover $notchedOutline': {
              borderColor: '#fe7303',
            },
            '&$focused $notchedOutline': {
              borderColor: '#fe7303',
              borderWidth: 2,
            },
          },
          notchedOutline: {
            borderColor: '#dde0e7',
          },
        },
        MuiInputBase: {
          root: {
            fontSize: '0.9375rem',
          },
        },
        MuiTableCell: {
          head: {
            fontWeight: 700,
            fontSize: '0.75rem',
            color: '#8e92a3',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            borderBottom: '2px solid #eaecf0',
            padding: '12px 16px',
            backgroundColor: '#f8f9fc',
          },
          body: {
            color: '#3f4254',
            borderBottom: '1px solid #f0f2f7',
            padding: '13px 16px',
          },
        },
        MuiTableRow: {
          root: {
            transition: 'background 0.15s',
            '&:hover': {
              backgroundColor: '#fff8f3 !important',
            },
          },
        },
        MuiListItem: {
          root: {
            borderRadius: 8,
          },
          gutters: {
            paddingLeft: 12,
            paddingRight: 12,
          },
        },
        MuiChip: {
          root: {
            borderRadius: 6,
            fontWeight: 600,
            fontSize: '0.75rem',
          },
          colorPrimary: {
            background: 'linear-gradient(135deg, #fe7303 0%, #ff9e45 100%)',
          },
        },
        MuiTooltip: {
          tooltip: {
            borderRadius: 6,
            fontSize: '0.8125rem',
            backgroundColor: '#1e2129',
          },
        },
        MuiLinearProgress: {
          root: {
            borderRadius: 4,
            height: 4,
          },
          colorPrimary: {
            backgroundColor: '#ffe8d5',
          },
          barColorPrimary: {
            background: 'linear-gradient(90deg, #fe7303, #ff9e45)',
          },
        },
      },
    },
  },
]

export default themes
